// extracted by mini-css-extract-plugin
export var active = "_mf-2";
export var recordingDot = "_mf-1";
export var recordingIndicator = "_mf-0";